/* global window */
import { parse } from 'qs';

const useSearchParams = () => {
  const { search } = window.location;
  return parse(search, { ignoreQueryPrefix: true });
};

export default useSearchParams;
